import React from 'react';
//@ts-ignore
import {GetFiltersByCategory,SortProductsByPrice,GetProductsBySite,GetProductsByCategory} from './../../themes/kent/utilities/dataFunctions';
//@ts-ignore
import {ParseCategoryIds,GeneralAssetUrl} from './../../themes/kent/utilities/constants';
//@ts-ignore
import {GetProductsByQuery, ReorderProducts} from './../../themes/kent/utilities/functions';
//@ts-ignore
import ProductTile from './../product-tile/./product-tile';
//@ts-ignore
import GridStructure from './../grid-structure/./grid-structure';
//@ts-ignore
import ScrollFadeIn from './../scroll-fade/./scroll-fade';

interface IProps {
  category?: any;
  brand?: any;
  year?:any;
}

interface IState {
  filters?:any;
  allProducts?:any;
  products?:any;
  category?:any;
  filterHidden?:any;
  updateKey?:any;
  activeFilter?:any;

}

class FilterableCategoryList extends React.Component<IProps>{

public state: IState;

  constructor(props: IProps) {
      super(props);
      this.state = {
        updateKey:0
      };
  }

  componentDidMount = () => {
    console.log(this.props)
    this.setup();
  }
  componentDidUpdate = () => {
    if(this.props.category != this.state.category){
      this.setup();
    }
  }
  setupFilters = async(products:any) =>{
    let filters: any = await GetFiltersByCategory(this.props.category);
    console.log(filters)
    let simplifiedFilters: any = [];
    for (let i = 0; i < filters.length; i++) {
      let id: any = filters[i].id;
      let filteredProducts: any = products.filter((product: any)=>product.attributes.productFilters && product.attributes.productFilters.indexOf(id) != -1);
      simplifiedFilters.push({
        title:filters[i].attributes.title,
        id:filters[i].id,
        count:filteredProducts.length,
      })
    }
    return simplifiedFilters;
  }
  setup= async()=>{
    let allProducts: any = await GetProductsBySite(this.props.brand,this.props.year)
    let products: any = await GetProductsByCategory(this.props.category,this.props.year)
    if(this.props.category== ParseCategoryIds.waterskiAccessories){
      let subcategories: any =["eXWdLrLB67","wENbAACsgJ","wWHALtqszI","d0YRfEtsAj","nQT5BhvKdr","E0PSCB2EXQ","EGjcB4SaTl","yhfFK8PcVu","wpEaSGJgND","f478Q8s5bg"]
      let productArray: any = allProducts;
      let additionalProducts: any = await productArray.filter((product: any) => product.attributes.slug == "ikayak-atlas-wheelie-bag" || product.attributes.slug == "lakeparty-boat-bumpers" || product.attributes.slug == "lakeparty-mega-bumper")
      products = await productArray.filter((product: any) => subcategories.indexOf(product.attributes.subcategory) != -1)
      products = products.concat(additionalProducts)
    }
    let filters: any = await this.setupFilters(products);
    let reorderedProducts: any = await ReorderProducts(products)
    if(this.props.category== ParseCategoryIds.waterskiAccessories){
      reorderedProducts = await SortProductsByPrice(reorderedProducts,'descending')
    }
    if(this.props.category== ParseCategoryIds.iSup){
      let productArray: any = allProducts;
      let additionalProducts: any = await productArray.filter((product: any) => product.attributes.slug == "ikayak-atlas-wheelie-bag")
      reorderedProducts = reorderedProducts.concat(additionalProducts)
    }
    if(this.props.category== ParseCategoryIds.iSup || this.props.category == ParseCategoryIds.radFadPads || this.props.category == ParseCategoryIds.waterMats || this.props.category == ParseCategoryIds.iLand){
      let productArray: any = allProducts;
      let additionalProducts: any = await productArray.filter((product: any) => product.attributes.slug == "tubes-electric-drop-stitch-pump" || product.attributes.slug == "paddle-atlas-handpump");
      reorderedProducts = reorderedProducts.concat(additionalProducts)
    }
    this.setState({
      'filters':filters,
      'allProducts':reorderedProducts,
      'products':reorderedProducts,
      'category':this.props.category
    })
  }
  toggleFilters = () =>{
    if(this.state.filterHidden){
      this.setState({
        filterHidden:false
      })
    } else{
      this.setState({
        filterHidden:true
      })
    }
  }
  filterProducts = (filter:any) =>{
    let id: any;
    let updateKey:any = this.state.updateKey;
    let allProducts:any = this.state.allProducts;
    let products:any;
    if(filter == "all"){
      products = allProducts;
      id = null;
    } else{
      id = filter.id;
      products = allProducts.filter((product: any)=>product.attributes.productFilters && product.attributes.productFilters.indexOf(id) != -1);
    }
    this.setState({
      updateKey:updateKey+1,
      activeFilter:id,
      products:products
    })
  }
  sortProducts = async (e:any) =>{
    let type:any = e.target.value;
    let updateKey = this.state.updateKey;
    let reorderedProducts;
    if(type == "automatic"){
      reorderedProducts = await ReorderProducts(this.state.products)
      console.log('reordering')
    }
    if(type == "priceAscending"){
      reorderedProducts = await SortProductsByPrice(this.state.products,'ascending')
      console.log('reordering')
    }
    if(type == "priceDescending"){
      reorderedProducts = await SortProductsByPrice(this.state.products,'descending')
      console.log('reordering')
    }
    console.log('setting state')
    this.setState({
      updateKey:updateKey+1,
      products:reorderedProducts
    })
  }

  render() {
    if(!this.state.category) return null;
    return (
      <div className="filterable-category-list secondary-background row full-width">
        <div className="tiny-padding hide-for-small" style={{padding:"20px", width:this.state.filterHidden ? "70px" : "300px", maxWidth:this.state.filterHidden ? "70px" : "300px"}}>
          <div>
            <img style={{height:30, width:30, marginBottom:20}} src={GeneralAssetUrl+'menu-black.png'} onClick={this.toggleFilters} />
            <div style={{opacity:this.state.filterHidden ? 0 : 1 }}>
              <h6>{'Sort By'}</h6>
              <select className="custom-select" onChange={this.sortProducts} style={{fontSize:".9em"}}>
                <option value="automatic">{'Automatic'}</option>
                <option value="priceAscending">{'Price: Low to High'}</option>
                <option value="priceDescending">{'Price: High to Low'}</option>
              </select>

              <h6 className={this.state.activeFilter ? "subheading" : ""} style={{cursor:"pointer", marginTop:"30px"}} onClick={()=>this.filterProducts('all')}>{'All ('+this.state.allProducts.length+')'}</h6>
              {this.state.filters && this.state.filters.map((data:any)=>{
                let activeClass:any = this.state.activeFilter == data.id ? "" : "subheading";
                return(
                  <h6 className={activeClass} style={{cursor:"pointer",marginTop:"20px"}} onClick={()=>this.filterProducts(data)}>{data.title+' ('+data.count+')'}</h6>
                )
              })}
            </div>
          </div>
        </div>
        <div className="show-for-small" style={{overflow:"hidden"}}>
          <div className="row full-width" style={{flexWrap:'nowrap', overflowX:'scroll', paddingLeft:'10px', paddingTop:"20px", paddingBottom:"20px"}}>
            {this.state.filters && this.state.filters.map((data:any)=>{
              let activeClass:any = this.state.activeFilter == data.id ? "" : "subheading";
              return(
                <div style={{display:"inline-block",cursor:"pointer",padding:"20px"}}><h6 className={activeClass} onClick={()=>this.filterProducts(data)} style={{whiteSpace:"nowrap"}}>{data.title+' ('+data.count+')'}</h6></div>
              )
            })}
          </div>
        </div>
        <div style={{width:'100%',flex:1}}>
          <GridStructure
            key={this.state.updateKey}
            columns={3}>
              {this.state.products && this.state.products.map((product:any) =>{
                return (<ScrollFadeIn><ProductTile year={this.props.year} product={product} /></ScrollFadeIn>)
              })}
            </GridStructure>
        </div>
      </div>
    );
  }
}

 export default FilterableCategoryList;
